// extracted by mini-css-extract-plugin
export default {"deleteButton":"ContractForm_deleteButton__KDHmY","drawerForm":"ContractForm_drawerForm__YsfQt"};